import { useEffect } from "react";
import { LandingNav } from "@/components/landing/LandingNav";
import { Hero } from "@/components/landing/Hero";
import { FeatureMarquee } from "@/components/landing/FeatureMarquee";
import { MoneyFlowSection } from "@/components/landing/MoneyFlowSection";
import { PrivacySection } from "@/components/landing/PrivacySection";
import { WebMobileSection } from "@/components/landing/WebMobileSection";
import { AISection } from "@/components/landing/AISection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { ClosingCTA } from "@/components/landing/ClosingCTA";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { useSmoothScroll } from "@/components/landing/motion";

const Landing = () => {
  useSmoothScroll();

  useEffect(() => {
    document.title = "BudgeAI — Understand your money, without the spreadsheet";
  }, []);

  return (
    <div className="min-h-screen bg-background font-sans text-foreground antialiased">
      <LandingNav />
      <main>
        <Hero />
        <FeatureMarquee />
        <MoneyFlowSection />
        <PrivacySection />
        <WebMobileSection />
        <AISection />
        <FeaturesSection />
        <ClosingCTA />
      </main>
      <LandingFooter />
    </div>
  );
};

export default Landing;
